import { render } from "./AlertIcon.vue?vue&type=template&id=1c5718cb&scoped=true"
const script = {}

import "./AlertIcon.vue?vue&type=style&index=0&id=1c5718cb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5718cb"]])

export default __exports__